import { Inline } from '../../design-system/inline/inline';
import { ViewProps } from './file-drop-zone';
import { FileDropZoneView } from './file-drop-zone-view';

type FileDropZoneInlineViewProps = Omit<ViewProps, 'variant'>;

export const FileDropZoneInlineView = (props: FileDropZoneInlineViewProps) => {
  return (
    <Inline space={3}>
      <FileDropZoneView {...props} variant="INLINE" />
    </Inline>
  );
};
